import {notificationSmsService} from "../../common/api.service";

const initialStates = {
    status: 'loading',
    form_data: {
        user_id: '',
        email_verified_at: false,
        send_change_password: '',
        send_ticket_reply: '',
        send_terminal_change_status: '',
        send_successful_transaction: '',
        sms_count_can_send:'',
        sms_price:'',
        send_loginSuspectedIPs:'',
        send_newRegisterSuspectedIPs:'',
        recharge_gateway_id: null
        // send_checkout: ''
    },
    recharge_price: 0,
    recharge_result_data: {},
    rechargeResultStatus: ''
}

const mutations = {
    loading(state) {
        state.status    = 'loading'
    },
    success(state, form_data) {
        state.status    = 'success'
        state.form_data = form_data
    },
    increment(state){
        state.form_data.sms_count_can_send++;
    },
    getRechargePrice(state, recharge_price) {
        state.getRechargePriceStatus = 'success'
        state.recharge_price = recharge_price
    },
    rechargeData(state, recharge_result_data) {
        state.status = 'success'
        state.recharge_result_data = recharge_result_data
    }
}

const getters = {
    status: ({status}) => status,
    form_data: ({form_data}) => form_data,
    recharge_price: ({recharge_price}) => recharge_price,
    getRechargePriceStatus: ({getRechargePriceStatus}) => getRechargePriceStatus,
    rechargeResultData: ({recharge_result_data}) => recharge_result_data,
    rechargeResultStatus: ({recharge_result_status}) => recharge_result_status
}

const actions = {
    increment:({commit})=>commit("increment"),
    fetch({commit}) {
        commit('loading')
        return notificationSmsService.fetch().then(response => {
            commit('success', response.data.data)
        })
    },
    getRechargePrice({commit}, response) {
        commit ('getRechargePrice', response.data.data)
    },
    rechargeData({commit}, tracking_code) {
        commit('loading')
        return notificationSmsService.getRechargeData(tracking_code).then(response => {
           commit('rechargeData', response.data.data)
        });
    }
}

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}